<template>
        <svg :class="svgClass" aria-hidden="true">
            <use :xlink:href="`#${icon}`" />
        </svg>
</template>

<script>
import { computed } from 'vue'
export default {
    name: 'SvgIcon',
    props: {
        icon: {
            type: String,
            required: true
        },
        class: {
            type: String,
            default: '',
        }
    },
    setup(props) {
        const svgClass = computed(() => {
            if(props.class) {
                return 'svg-icon ' + props.class
            } else {
                return 'svg-icon'
            }
        })
        return {
            svgClass
        }
    },
}
</script>

<style lang="less" scoped>
.svg-icon {
    width: 1rem;
    height: 1rem;
    fill: currentColor !important;
    overflow: hidden;
}
</style>